// extracted by mini-css-extract-plugin
var _1 = "Actions__Actions___PRd4x";
var _2 = "Actions__wiggle___Poz_w";
export { _1 as "Actions", _2 as "wiggle" }
